// extracted by mini-css-extract-plugin
export default {"container":"rfysZ","desktop":"fGC8p","description":"hEig_","mobile":"IUnbf","smallMobile":"QV0ot"};